import { LegendLabel } from '@modules/charts/types';
import { getChartLabelIdOrName } from '@modules/charts/utils';
import { GetChartLabelOptions } from '@modules/common/types';
import { FieldNames } from 'v2/core/entities/fields';
import { HorizontalLegend } from '../HorizontalLegend';
import { VerticalLegend } from '../VerticalLegend';

interface LineChartLegendProps {
  labels: LegendLabel[];
  fieldName: FieldNames | undefined;
  isSmallSize: boolean;
  getColor?: (index: number, label: LegendLabel) => string;
  getLabelOptions?: GetChartLabelOptions;
  shouldShowLegendsInNewRow?: boolean;
  onMouseEnter?: (event: React.MouseEvent, index: number) => void;
  onMouseLeave?: (event: React.MouseEvent) => void;
}

export const LineChartLegend = ({
  labels,
  fieldName,
  isSmallSize,
  getColor,
  getLabelOptions,
  shouldShowLegendsInNewRow = false,
  onMouseEnter,
  onMouseLeave,
}: LineChartLegendProps) => {
  if (labels.length === 0) {
    return null;
  }

  const legendLabels = labels.map((label) => ({
    ...label,
    name: getChartLabelIdOrName(label.name),
  }));

  if (isSmallSize || shouldShowLegendsInNewRow) {
    return (
      <HorizontalLegend
        labels={legendLabels}
        fieldName={fieldName}
        getColor={getColor}
        getLabelOptions={getLabelOptions}
        shouldShowLegendsInNewRow={shouldShowLegendsInNewRow}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      />
    );
  }

  return (
    <VerticalLegend
      labels={legendLabels}
      fieldName={fieldName}
      getColor={getColor}
      variant="small"
      getLabelOptions={getLabelOptions}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    />
  );
};
